
import { map } from 'rxjs/operators';
/*-------------------------------------------------------------------

  Project Name 		        :	FieldPower

  Description			    :	Technician Master Service

  Copyright			        :   Zylog Systems Ltd.

  Modifications History     :                                                                 
  ------------------------------------------------------------------- 
  Date	        By                       Function Name        Remarks/Reason                        
  -------------------------------------------------------------------                      
  01 Mar 2017   Anvardeen Batcha B                               Created

  ------------------------------------------------------------------*/

import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs';

import { API } from '../../core/app-config';
import { FPResponse, GlobalInfo } from '../../shared/shared.model';
import { SharedService } from '../../shared/shared.service';
import { Technician, TechnicianList, Vendor, Manger, Reason, TechCFModel, TechnicianDetail, Country, Address, Zone, Region, WorkType, TechnicianRegion, TechnicianWorkType, TechnicianSkill, TechnicianCertifiacation, Logo, Warehouse, WorkStartAddress, GeoFencingMap, TechnicianFilterEntity, FilterDetailsEntity, VendorEntity } from '../technician/technician.models';
import { SystemSettings } from '../../technician/technician-jobs/technician-jobs.models';

@Injectable()
export class TechnicianService {

    constructor(private http: Http, sharedService: SharedService) { }

    getTechnicians(CompanyId: number, LoginId: number, MaxRoleGroup: number, VendorId: number): Observable<Technician[]> {
        return this.http.get(API.USER + "/GetAllTechnician/" + CompanyId + "/" + LoginId + "/" + MaxRoleGroup + "/" + VendorId).pipe(map(res => {
            var techs = <any>res.json();
            return techs.TechnicianLists;
        }));
    }

    //PT-1240 --  added by anvardeen batcha
    delete(CompanyId: number, Id: number, LastChangedBy: number): Observable<FPResponse> {
        return this.http.delete(API.TECHNICIAN + '/DeleteTechnician/' + CompanyId + '/' + Id + "/?LastChangedBy=" + LastChangedBy).pipe(map(res => res.json()));
    }

    getVendor(CompanyId: number, Id: number): Observable<Vendor[]> {
        return this.http.get(API.VENDOR + "/GetVendor/" + Id + "/" + CompanyId).pipe(map(res => res.json()));
    }

    getManager(CompanyId: number, Id: number, LoginId: number): Observable<Manger[]> {
        return this.http.get(API.USER + "/GetManager/" + Id + "/" + CompanyId + "/" + LoginId).pipe(map(res => res.json()));
    }

    getTechnician(CompanyId: number, Id: number): Observable<TechnicianDetail> {
        return this.http.get(API.USER + "/GetTechnician/" + CompanyId + "/" + Id).pipe(map(res => res.json()));
    }

    getInactiveReason(CompanyId: number, Id: number): Observable<Reason[]> {
        return this.http.get(API.CONFIGMASTER + "/GetAll/" + CompanyId + "/" + Id).pipe(map(res => res.json()));
    }

    updateTechnicain(technicianDetail: TechCFModel): Observable<FPResponse> {
        return this.http.put(API.USER + "/UpdateTechDetails/", technicianDetail).pipe(map(res => res.json()));
    }

    updateTechWarehouse(technicianDetail: TechnicianDetail): Observable<FPResponse> {
        return this.http.put(API.USER + "/UpdateTechWarehouse/", technicianDetail).pipe(map(res => res.json()));
    }

    getCountry(IsActive: number, Id: number): Observable<Country[]> {
        return this.http.get(API.REGION + "/GetCountry/" + IsActive + "/" + Id).pipe(map(res => res.json()));
    }

    getAddress(CompanyId: number, Id: number): Observable<Address> {
        return this.http.get(API.USER + "/GetTechAddress/" + CompanyId + "/" + Id).pipe(map(res => res.json()));
    }

    updateTechnAddress(address: Address, techid: number): Observable<FPResponse> {
        return this.http.put(API.USER + "/UpdateTechAddress/" + techid, address).pipe(map(res => res.json()));
    }

    //  getWorkStartAddress(CompanyId: number, Id: number): Observable<Address> {
    //     return this.http.get(API.USER + "/GetWorkStartAddress/" + CompanyId + "/" + Id).map<Address>(res => res.json());
    // }

    // getZones(companyId: number, loginId: number): Observable<Zone[]> {
    //     return this.http.get(API.COMMON + '/GetZones/' + companyId + "/" + loginId)
    //         .map<Zone[]>(res => res.json());
    // }

    getZones(companyId: number, loginId: number): Observable<Zone[]> {
        return this.http.get(API.WOVENDOR + '/GetVendorZones/' + companyId + "/" + loginId).pipe(
            map(res => res.json()));
    }

    getVendorAvailZones(companyId: number, loginId: number): Observable<Zone[]> {
        return this.http.get(API.WOVENDOR + '/GetVendorAvailZones/' + companyId + "/" + loginId).pipe(
            map(res => res.json()));
    }

    getAvailableTechRegion(companyId: number, id: number, zoneId: number): Observable<Region[]> {
        return this.http.get(API.TECHNICIAN + '/GetTechAvailableRegion/' + companyId + "/" + id + "/" + zoneId).pipe(map(res => res.json()));
    }

    getAllottedTechRegion(companyId: number, id: number, zoneId: number): Observable<Region[]> {
        return this.http.get(API.TECHNICIAN + '/GetTechAllottedRegion/' + companyId + "/" + id + "/" + zoneId).pipe(map(res => res.json()));
    }

    //work type
    GetTechAvailableWorktype(companyId: number, id: number, vendorid: number): Observable<WorkType[]> {
        return this.http.get(API.TECHNICIAN + '/GetTechAvailableWorkType/' + companyId + "/" + id + "/" + vendorid).pipe(map(res => res.json()));
    }

    GetTechAllottedWorktype(companyId: number, id: number): Observable<WorkType[]> {
        return this.http.get(API.TECHNICIAN + '/GetTechAllottedWorktype/' + companyId + "/" + id).pipe(map(res => res.json()));
    }

    insertTechRegion(selectedRegion: TechnicianRegion): Observable<FPResponse> {
        return this.http.post(API.TECHNICIAN + '/InsertTechRegion', selectedRegion).pipe(map(res => res.json()));
    }

    insertTechWorkType(selectedWorkType: TechnicianWorkType): Observable<FPResponse> {
        return this.http.post(API.TECHNICIAN + '/InsertTechWorkType', selectedWorkType).pipe(map(res => res.json()));
    }

    //Added By Arumugam  for TechnicianFilterExcelDownload 13-02-2019
    getTechnicianFilterExcelDownload(Technicianfilter: TechnicianFilterEntity) {
        return this.http.post(API.VENDOR + '/TechnicianExcelDownload', Technicianfilter, { responseType: ResponseContentType.Blob }).pipe();

    }
    getTechSkills(companyId: number, id: number): Observable<TechnicianSkill[]> {
        return this.http.get(API.TECHNICIAN + '/GetTechSkills/' + companyId + "/" + id).pipe(map(res => res.json()));
    }

    getTechAvailSkills(companyId: number, id: number): Observable<TechnicianSkill[]> {
        return this.http.get(API.TECHNICIAN + '/GetTechAvailSkills/' + companyId + "/" + id).pipe(map(res => res.json()));
    }

    insertTechSkill(techSkill: TechnicianSkill): Observable<FPResponse> {
        return this.http.post(API.TECHNICIAN + '/InsertTechSkill', techSkill).pipe(map(res => res.json()));
    }

    deleteTechSkill(companyId: number, id: number, skillId: number): Observable<FPResponse> {
        return this.http.delete(API.TECHNICIAN + '/DeleteTechSkill/' + companyId + '/' + id + '/' + skillId).pipe(map(res => res.json()));
    }

    getTechCertifications(companyId: number, id: number): Observable<TechnicianCertifiacation[]> {
        return this.http.get(API.TECHNICIAN + '/GetTechCetification/' + companyId + "/" + id).pipe(map(res => res.json()));
    }

    getTechAvailCertifications(companyId: number, id: number): Observable<TechnicianCertifiacation[]> {
        return this.http.get(API.TECHNICIAN + '/GetTechAvailCertifications/' + companyId + "/" + id).pipe(map(res => res.json()));
    }

    insertTechCertification(techCertifiacation: TechnicianCertifiacation): Observable<FPResponse> {
        return this.http.post(API.TECHNICIAN + '/InsertTechCertification', techCertifiacation).pipe(map(res => res.json()));
    }

    updateTechCertifiacation(techCertifiacation: TechnicianCertifiacation): Observable<FPResponse> {
        return this.http.put(API.TECHNICIAN + '/UpdateTechCertifications', techCertifiacation).pipe(map(res => res.json()));
    }

    deleteTechCertification(companyId: number, id: number, certificationId: number): Observable<FPResponse> {
        return this.http.delete(API.TECHNICIAN + '/DeleteTechCertifications/' + companyId + '/' + id + '/' + certificationId).pipe(map(res => res.json()));
    }

    //Photo Download
    GetUserTheme(CompanyId: number, FileName: string): Observable<Logo> {
        return this.http.get(API.USER + "/GetUserTheme/?CompanyId=" + CompanyId + "&FileName=" + FileName).pipe(map(res => res.json()));
    }

    getWarehouse(CompanyId: number, WarehouseTypeId: number): Observable<Warehouse[]> {
        return this.http.get(API.WAREHOUSE + "/GetWarehouse/" + CompanyId + "/" + WarehouseTypeId).pipe(map(res => res.json()));
    }

    getTechWorkStartAddr(CompanyId: number): Observable<WorkStartAddress[]> {
        return this.http.get(API.USER + "/GetTechWorkStartAddr/" + CompanyId).pipe(map(res => res.json()));
    }

    getSystemSettings(companyId: number, settingsId: number[]): Observable<SystemSettings[]> {
        return this.http.post(API.WORKORDER + '/GetSystemSettings', { CompanyId: companyId, SettingsId: settingsId }).pipe(
            map(res => res.json()));
    }

    getGeoFencingDetails(companyId: number, loginId: number, jobId: number): Observable<GeoFencingMap[]> {
        return this.http.post(API.TECH_AVAILABILITY + '/GetGeoFencingDetails/' + companyId + '/' + loginId + '/' + jobId, '').pipe(
            map(res => res.json()));
    }
    TechRoleCheck(companyId: number, Techid: number): Observable<number> {
        return this.http.get(API.TECH_AVAILABILITY + '/TechRoleCheck?CompanyId=' + companyId + '&Techid=' + Techid).pipe(map(res => res.json()));

    }

    getVendorList(CompanyId: number, LoginId: number, MaxRoleGroup: number, ProjectId: string, VendorId?: number): Observable<VendorEntity[]> {
        return this.http.get(API.USER + "/GetVendorList/" + CompanyId + "/" + LoginId + "/" + MaxRoleGroup + "/?ProjectId=" + ProjectId + '&VendorId=' + VendorId).pipe(map(res => res.json()));
    }
}